import { render, staticRenderFns } from "./CancelarAbono.vue?vue&type=template&id=2b5712c7"
import script from "./CancelarAbono.vue?vue&type=script&lang=js"
export * from "./CancelarAbono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports